<template>
  <div class="master-order-selector">
    <nav class="nav-bar-alternative">
      <ul class="nav-bar-nav">
        <li
          v-for="(order, index) in orders"
          :id="`master-order-item-${index}`"
          :key="order.id || index"
          class="nav-item"
          :class="[{ selected: index === selectedOrderIndex }]"
          v-on:click="selectOrder(index)">
          <div class="content-cnt">
            <div class="labels">
              <p class="title">
                {{ order.title }}
              </p>
              <p class="second">
                {{ order.subTitle }}
              </p>
            </div>
            <div v-if="index === selectedOrderIndex" class="action-icons">
              <div v-if="enableEditButton" class="ico ico-edit" v-on:click="editOrder(index)"></div>
              <div v-if="showCloneButton" class="ico ico-duplicate" v-on:click="cloneOrder(index)"></div>
              <div v-if="enableDeleteButton" class="ico ico-delete" v-on:click="deleteOrder(index)"></div>
            </div>
          </div>
        </li>
      </ul>
      <BackstageButton v-if="enableAddButton" icon-right="addition-sign" v-on:click="addNewOrder" />
    </nav>
  </div>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue';
import { MasterOrderSelectorModel } from '../../models/master-order-selector.model';
import BackstageButton from '../common/BackstageButton.vue';

export default defineComponent({
  name: 'master-order-selector',
  components: {
    BackstageButton,
  },
  props: {
    orders: {
      type: Array as PropType<MasterOrderSelectorModel[]>,
      default: () => [],
    },
    enableAddButton: {
      type: Boolean,
      default: false,
    },
    enableEditButton: {
      type: Boolean,
      default: false,
    },
    enableCloneButton: {
      type: Boolean,
      default: false,
    },
    enableDeleteButton: {
      type: Boolean,
      default: false,
    },
    selectedOrderIsValid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const selectedIndex = this.orders.findIndex((order: MasterOrderSelectorModel) => order.selected);

    return {
      selectedOrderIndex: selectedIndex !== -1 ? selectedIndex : 0,
    };
  },
  computed: {
    showCloneButton(): boolean {
      const isEmptyOrder = this.orders[this.selectedOrderIndex].subTitle.startsWith('0');

      return this.enableCloneButton && !isEmptyOrder;
    },
  },
  methods: {
    selectOrder(index: number) {
      if (!this.selectedOrderIsValid) {
        return;
      }

      this.selectedOrderIndex = index;
      this.$emit('select-order', index);
    },
    addNewOrder() {
      this.$emit('add-new-order');
    },
    editOrder(index: number) {
      this.$emit('edit-order', index);
    },
    deleteOrder(index: number) {
      this.$emit('delete-order', index);
    },
    cloneOrder(index: number) {
      this.$emit('clone-order', index);
    },
  },
});
</script>
